import { Vue, Component, Prop } from 'vue-property-decorator'
import Product from '~/types/api/Product'
import ImageElement from '~/components/element/ImageElement'
import SectionHelper from '~/utils/sectionHelper'
import s from '~/utils/s'
import Img from '~/types/api/Img'

@Component
export default class ProductCardAnalogs extends Vue {
  @Prop({ type: Object, required: true })
  readonly product!: Product

  @Prop({ type: Number, default: 0 })
  readonly position?: number

  get title (): string {
    return this.product.title
  }

  get link (): string {
    const helper = new SectionHelper(s(this.$store).general.sections, this.$store)
    const sections = this.product.sectionId
    return helper.getProductLink(sections?.length ? sections[0] : s(this.$store).categoryPage.category.id, this.product.seoUrl ?? this.product.id)
  }

  get defaultImg (): Img {
    return {
      d: require('~/assets/image/pill.png'),
      t: require('~/assets/image/pill.png'),
      m: require('~/assets/image/pill.png')
    }
  }

  renderImage () {
    if (this.product.img) {
      return (
        <ImageElement {...{
          props: {
            img: Object.keys(this.product.img).length !== 0 ? this.product.img : this.defaultImg,
            isMicrodata: true,
            title: s(this.$store).seo.imgTitle,
            alt: s(this.$store).seo.imgAlt
          }
        }} />
      )
    }
  }

  renderPriceWrapper () {
    return (
      <div class="product-card__price-wrapper analog">
        <div class="product-card__price-container analog">
          <div class={this.product.price.toString().length > 5 ? 'product-card__greater-price analog' : 'product-card__price analog'} itemprop="offers" itemscope itemtype="https://schema.org/Offer">
            <span itemprop="price" content={this.product.price}>{this.product.price}</span>
            <span itemprop="priceCurrency" content="RUB"> ₽</span>
            <meta itemprop="availability" href="https://schema.org/InStock" content="InStock" />
          </div>
        </div>
      </div>
    )
  }

  render () {
    return (
      <div class="product-card__list-element analog" itemscope itemtype="https://schema.org/ListItem" itemprop="itemListElement">
        <meta itemprop="position" content={this.position} />
        <div class={{
          'product-card analog': true
        }} itemscope itemtype="https://schema.org/Product" itemprop="item" data-id={this.product.id}>
          <meta itemprop="name" content={this.title} />
          <meta itemprop="url" content={this.link} />
          <div class="product-card__tags-catlog-wrapper analog">
          </div>
          <div class="product-card__image-wrapper analog">
            <nuxt-link to={this.link}>
              {this.renderImage()}
            </nuxt-link>
          </div>
          <div class="product-card__info-wrapper analog">
            <div class="product-card__info-title analog">
              <nuxt-link to={this.link} class="product-card__info-title analog" title={this.title}>
                <div class="product-card__info-title-text">
                  {this.title}
                </div>
              </nuxt-link>
            </div>
          </div>
          {this.renderPriceWrapper()}
        </div>
      </div>
    )
  }
}
